import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timerProgressBar: true,
  didOpen: (el) => {
    el.addEventListener('mouseenter', Swal.stopTimer);
    el.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const toast = {
  success: (message: string) =>
    Toast.fire({ icon: 'success', title: message, timer: 3000 }),

  error: (message: string) =>
    Toast.fire({ icon: 'error', title: message, timer: 4000 }),

  warning: (message: string) =>
    Toast.fire({ icon: 'warning', title: message, timer: 3500 }),

  info: (message: string) =>
    Toast.fire({ icon: 'info', title: message, timer: 3000 }),

  confirm: async (
    message: string,
    title = 'Are you sure?',
    confirmText = 'Yes',
    cancelText = 'Cancel',
  ): Promise<boolean> => {
    const result = await Swal.fire({
      title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
    });
    return result.isConfirmed;
  },
};
